import TomSelect from "tom-select"

class CustomTomSelect extends TomSelect {
  
  constructor(selector, options = {}) {

    const defaultOptions = { 
      labelField: "name",
      valueField: "id",
      searchField: "name",
      placeholder: "Rechercher...",
      loadThrottle: 400,
      render: {
        loading: function(data, escape) {
          return `<div class="px-4 py-2 help-text text-smaller">Chargement...</div>`
        },
        no_results: function(data, escape) {
          if (!data.input.length || options.create) return ""
          return `<div class="px-4 py-2 help-text text-smaller">Aucun résultat trouvé</div>`
        },
        option: function(data, escape) {
          const dataAttrs = Object.keys(data).map(key => `data-${key}="${data[key]}"`).join(" ")
          return `
            <div class="px-4 py-2 flex flex-col gap-1" ${dataAttrs}>
              <div class="flex items-center gap-2">
                ${data.prefix ? `<span class="text-xs text-gray-500 leading-[1] relative top-px">${escape(data.prefix)}: </span>` : ""}
                <span class="text-gray-900">${escape(data.label || data.name)}</span>
              </div>
              ${data.description ? `<span class="text-xs text-gray-500">${escape(data.description)}</span>` : ""}
            </div>
          `
        },
        option_create: function(data, escape) {
          return `
            <div class="create !px-3 !py-2 flex flex-col gap-1">
              <div class="flex items-center gap-2">
                <span class="text-gray-500">Créer:</span>
                <span class="text-gray-900">${escape(data.input)}</span>
              </div>
            </div>
          `
        }
      }
    }
    super(selector, { ...defaultOptions, ...options })
  }

  getSelection() {
    return this.items.map(value => this.options[value])
  }

  async fetchOptions(url, { focus = false } = {}) {
    this.clear(true)
    this.clearOptions()
    const response = await fetch(url, { headers: { accept: "application/json" } })
    const results = await response.json()
    this.addOptions(results)
    if (focus) this.focus()
  }

  clearSelect() {
    this.clear(true)
    this.clearOptions()
    // Restore initial options if they exist
    if (this.initialOptions) {
      this.addOptions(this.initialOptions)
    }
  }

  setInitialOptions(options) {
    this.initialOptions = options
  }
  
}

export default CustomTomSelect